<template>
    <div class="">
        <router-view></router-view>
        <router-view name="tabBar"></router-view>
    </div>
</template>

<script>

    export default {
        name: 'container_main',
        components: {},
        data() {
            return {
                showTabBar: true
            }
        },
        mounted() {

        },
        methods: {

        }
    }
</script>

<style>
    .grid {
        font-size: 14px;
        text-align: center;
        padding: 20px 10px;
    }

    .grid img {
        width: 28px;
        height: 28px;
    }

    .center {
        text-align: center;
    }
</style>
